import { GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP } from "./methodology-lookup";
const businessTravel = GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.sectors.BUSINESS_TRAVEL;
export const GHG_ADMIN_APPLICABLE_SUBSECTOR_IDS_BY_ENERGY_SOURCE_ID = {
    [businessTravel.energySources.KEROSENE.id]: [businessTravel.subsectors.BUSINESS_TRAVEL_AIR.id],
};
